"use client";
import ProducrCard from "@/components/Product/ProducrCard";
import { ProductListItemFragment } from "@/gql/graphql";
import { Button, Empty, message, Spin } from "antd";
import React, { useState, useCallback } from "react";
import { fetchProductByCategoryData, fetchProductData } from "@/lib/api/product";

const ProductList = ({
	products,
	locale,
	channel,
	slug,
}: {
	products: any;
	locale: string;
	channel: string;
	slug?: string;
}) => {
	// 搜索页面无loadmore ==> ?
	const [hasMore, setHasMore] = useState(products?.pageInfo?.hasNextPage);
	const [moreLoading, setMoreLoading] = useState(false);
	const [after, setAfter] = useState(products?.pageInfo?.endCursor);
	const [productsList, setProductsList] = useState(products);

	const onLoadMore = useCallback(async () => {
		try {
			setMoreLoading(true);
			let res = null;
			if (slug) {
				res = (await fetchProductByCategoryData({ slug, locale, channel, after }))?.category;
			} else {
				res = await fetchProductData({ locale, channel, after });
			}
			setProductsList((prev) => ({
				...prev,
				edges: [...prev.edges, ...res.products.edges],
			}));
			setHasMore(res.products.pageInfo.hasNextPage);
			setAfter(res.products.pageInfo.endCursor);
		} catch (e) {
			message.error(e.message);
		} finally {
			setMoreLoading(false);
		}
	}, [locale, channel, after]);

	return (
		<>
			{!productsList?.edges.length && <Empty />}
			<div className="grid flex-1 grid-cols-3 gap-5 p-4 max-md:grid-cols-2 max-md:p-2">
				{productsList?.edges.map((item) => (
					<ProducrCard
						key={item.node.slug}
						productItem={item.node as ProductListItemFragment}
						locale={locale}
					/>
				))}
			</div>
			{moreLoading ? (
				<Spin />
			) : (
				hasMore && (
					<div className="mt-5 flex justify-center">
						<Button onClick={onLoadMore} type="primary" shape="round">
							Load More
						</Button>
					</div>
				)
			)}
		</>
	);
};

export default ProductList;
